const fs = require("fs");

export const isValidEmail = (email: string) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );
};

export const isValidPhoneNumber = (number?: string) => {
  const phoneRegex = /([\+[0-9]|[0-9]|0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b/;
  if (number) {
    return phoneRegex.test(number);
  } else return true;
};
